import axios from "axios";
import {
  BaseResponse,
  LoginResponse,
  ShipperResponse,
} from "types/responses.type";
import config from "../config";

export interface LoginRequest {
  email: string;
  password: string;
}

const api = axios.create({
  baseURL: config.api.baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add auth token and shipper header to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("owlara_token");
  const user = JSON.parse(localStorage.getItem("owlara_user") || "null");
  const selectedShipperId = localStorage.getItem("owlara_selected_shipper");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Add shipper header based on user type and selected shipper
  if (user?.type && ["ADMIN", "SUPPORT"].includes(user.type)) {
    config.headers["x-shipper-id"] = selectedShipperId;
  }

  return config;
});

// Redirect to login page on 401 error
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Remove auth info and redirect to login
      localStorage.removeItem("owlara_token");
      localStorage.removeItem("owlara_user");
      localStorage.removeItem("owlara_selected_shipper");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export const authApi = {
  login: async (
    credentials: LoginRequest
  ): Promise<BaseResponse<LoginResponse>> => {
    try {
      const response = await api.post("/auth/login", credentials);
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as BaseResponse<LoginResponse>;
      }
      return {
        ok: false,
        errorMessage: "An unexpected error occurred",
      };
    }
  },

  logout: () => {
    localStorage.removeItem("owlara_token");
    localStorage.removeItem("owlara_user");
  },
};

export default api;
